export const isNumber = number =>
  !Number.isNaN(parseFloat(number)) && Number.isFinite(parseFloat(number));

export const addResizeEndListener = (element, callback) => {
  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(callback);
    resizeObserver.observe(element);

    return resizeObserver;
  }

  if (!('ResizeObserver' in window)) {
    let resizeTimeout = null;
    const resizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(callback, 400);
    };

    window.addEventListener('resize', resizeHandler);

    return resizeHandler;
  }

  return null;
};

export const removeResizeEndListener = (element, listener) => {
  if ('ResizeObserver' in window) {
    listener.unobserve(element);
  }

  if (!('ResizeObserver' in window)) {
    window.removeEventListener('resize', listener);
  }
};

export const getDimensions = target => {
  if (typeof target === 'string') {
    return document.getElementById(target).getBoundingClientRect();
  }

  return target.getBoundingClientRect();
};

export const getScrollTop = () =>
  window.pageYOffset ||
  document.documentElement.scrollTop ||
  document.body.scrollTop;

export const getScrollLeft = () =>
  window.pageXOffset ||
  document.documentElement.scrollLeft ||
  document.body.scrollLeft;

export const getCoords = elem => {
  const box = elem.getBoundingClientRect();

  const { body, documentElement } = document;

  const scrollTop = getScrollTop();
  const scrollLeft = getScrollLeft();

  const clientTop = documentElement.clientTop || body.clientTop || 0;
  const clientLeft = documentElement.clientLeft || body.clientLeft || 0;

  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;

  return {
    top,
    left,
  };
};

export const closest = (target, parent) => {
  if (!target) return false;
  return parent === target || closest(target.parentNode, parent);
};

export const disableScroll = () => {
  document.documentElement.style.overflow = 'hidden';
};

export const enableScroll = () => {
  document.documentElement.style.overflow = '';
};

export const isServer = () => typeof window === 'undefined';

export const isClient = () => typeof window !== 'undefined';

export default isNumber;

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};
